export default __webpack_public_path__ + "svg/calendar/2025/4/junio.svg?39b56c5d";